export default [
  {
    path: '/marks',
    name: 'marks',
    component: () => import("@/views/Page/marks/marks.vue"),
    meta: {
      title: '#Default# | marks',
    },
  },
  {
    path: '/section-marks',
    name: 'sectionMarks',
    component: () => import("@/views/Page/marks/SectionMarks.vue"),
    meta: {
      title: '#Default# | Section Marks',
    },
  }
];

